import { render } from "./RxFooter.vue?vue&type=template&id=6203bb02"
import script from "./RxFooter.vue?vue&type=script&lang=js"
export * from "./RxFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__